import React from "react";

const links = [
  { icon: "✉️", label: "Email", value: "ravindrabirla20@gmail.com", href: "mailto:ravindrabirla20@gmail.com" },
  { icon: "📱", label: "Phone", value: "+91 95759 21390", href: "tel:+919575921390" },
  { icon: "🐙", label: "GitHub", value: "github.com/Birlaravi", href: "https://github.com/Birlaravi/" },
  { icon: "💼", label: "LinkedIn", value: "ravindra-birla", href: "https://www.linkedin.com/in/ravindra-birla-5a6a281b4" },
];

const Contact = () => {
  return (
    <section id="contact" style={{ padding: "6rem 5%" }}>
      <div className="section-inner">
        <p className="section-label">Say hello</p>
        <h2 className="section-title">Get in touch</h2>
        <div className="contact-wrapper">
          <div className="contact-info">
            <p>
              Open to full-time roles, freelance projects, and interesting collaborations.
              Whether it's Angular, PostgreSQL, or something new — I'd love to hear about it.
            </p>
            <div className="contact-links">
              {links.map((l) => (
                <a key={l.label} href={l.href} className="contact-link" target={l.href.startsWith("http") ? "_blank" : undefined} rel="noopener noreferrer">
                  <div className="cl-icon">{l.icon}</div>
                  <div>
                    <div className="cl-label">{l.label}</div>
                    <div className="cl-value">{l.value}</div>
                  </div>
                </a>
              ))}
            </div>
          </div>

          <div className="contact-form-card">
            <h3>Send a message</h3>
            <p>
              Reach out directly by email or drop a quick note — I typically respond within 24 hours.
            </p>
            <div className="form-row"><input placeholder="Your name" type="text" /></div>
            <div className="form-row"><input placeholder="your@email.com" type="email" /></div>
            <div className="form-row">
              <textarea rows={4} placeholder="What would you like to discuss?" />
            </div>
            <a
              href="mailto:ravindrabirla20@gmail.com"
              className="btn-primary"
              style={{ width: "100%", justifyContent: "center" }}
            >
              Send via Email →
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Contact;
